import { util } from '../util'
import { strings } from '../context/LanguageContext/strings'

export const ManageImports = {
    getActions: () => [
        {
            value: 'update',
            display: strings.UPDATE,
        },
        {
            value: 'delete',
            display: strings.DELETE,
        },
    ],
    importsTableDefaultRows: 50,
    importsTableRows: [50, 100, 200],
    importsTableSortBy: 'created_at',
    importsTableSortOrder: 'desc',
    getStatuses: () => [
        {
            value: 'pending',
            display: strings.PENDING,
        },
        {
            value: 'rejected',
            display: strings.REJECTED,
        },
        {
            value: 'success',
            display: strings.SUCCESS,
        },
    ],
    StatusIcons: {
        success: {
            success: util.CheckCircleIcon,
            color: 'success',
            pointer: false,
            size: 'xxs',
        },
        rejected: {
            rejected: util.CancelIcon,
            color: 'danger',
            pointer: false,
            size: 'xxs',
        },
        pending: {
            pending: util.ReportProblemOutlinedIcon,
            color: 'warning',
            pointer: false,
            size: 'xxs',
        },
    },
}
